(function() {
  vtex.define('shipping/script/mixin/withLogisticsInfo',[], function() {
    return function() {
      this._mapLogisticsInfo = function(logisticsInfo, items, sellers) {
        var newLogisticsInfo;
        newLogisticsInfo = _.map(logisticsInfo, function(logisticItem) {
          var newLogisticItem, seller, _ref;
          newLogisticItem = {
            itemIndex: logisticItem.itemIndex,
            itemId: logisticItem.itemId,
            selectedSla: logisticItem.selectedSla,
            shipsTo: (_ref = logisticItem.shipsTo) != null ? _ref.slice(0) : void 0
          };
          newLogisticItem.slas = _.map(logisticItem.slas, function(sla) {
            var newSla;
            newSla = {
              id: sla.id,
              listPrice: sla.listPrice,
              name: sla.name,
              price: sla.price,
              shippingEstimate: sla.shippingEstimate,
              shippingEstimateDate: sla.shippingEstimateDate,
              deliveryWindow: _.extend({}, sla.deliveryWindow),
              tax: sla.tax,
              pickupName: sla.pickupStoreInfo && sla.pickupStoreInfo.friendlyName
            };
            newSla.availableDeliveryWindows = _.map(sla.availableDeliveryWindows, function(dw) {
              return _.extend({}, dw);
            });
            return newSla;
          });
          newLogisticItem.item = items[newLogisticItem.itemIndex];
          seller = _.find(sellers, function(seller) {
            return String(seller.id) === String(newLogisticItem.item.seller);
          });
          newLogisticItem.seller = seller;
          return newLogisticItem;
        });
        return newLogisticsInfo;
      };
      this._fillSLA = function(index, sla, sellerId, selectedSla) {
        var defaultWindow, _ref;
        sla.shippingOptionsIndex = index;
        if (sla.availableDeliveryWindows && sla.availableDeliveryWindows.length > 0) {
          sla.isScheduled = true;
          defaultWindow = sla.availableDeliveryWindows[0];
          sla.hasPriceVariation = _.some(sla.availableDeliveryWindows, function(win) {
            var isPriceAndTaxEqual, isPriceAndTaxZero;
            isPriceAndTaxZero = win.price === 0 && win.tax === 0;
            isPriceAndTaxEqual = win.price === defaultWindow.price && win.tax === defaultWindow.tax;
            return !(isPriceAndTaxZero || isPriceAndTaxEqual);
          });
        }
        sla.businessDays = (sla.shippingEstimate + '').indexOf('bd') !== -1;
        sla.days = (sla.shippingEstimate + '').indexOf('d') !== -1;
        sla.hours = (sla.shippingEstimate + '').indexOf('h') !== -1;
        sla.minutes = (sla.shippingEstimate + '').indexOf('m') !== -1;
        sla.shippingEstimateTime = parseInt((sla.shippingEstimate + '').split(/\D+/)[0]);
        sla.nameAttr = _.plainChars('seller-' + sellerId);
        sla.idAttr = _.plainChars(sla.nameAttr + '-sla-' + ((_ref = sla.id) != null ? _ref.replace(/\ /g, '') : void 0));
        if (sla.id === selectedSla) {
          sla.isSelected = true;
        } else {
          sla.isSelected = false;
        }
        return sla;
      };
      this._createPriceLabels = function(sla) {
        if (sla.price > 0) {
          sla.valueLabel = _.intAsCurrency(sla.price);
        } else {
          sla.valueLabel = i18n.t('global.free');
        }
        if (sla.tax > 0) {
          sla.taxValueLabel = _.intAsCurrency(sla.tax);
        } else {
          sla.taxValueLabel = i18n.t('global.free');
        }
        return sla;
      };
      this._fillLogisticsInfo = function(logisticsInfoBySeller) {
        var index, logisticsInfoArray,
          _this = this;
        index = 0;
        logisticsInfoArray = _.map(logisticsInfoBySeller, function(logisticsInfo) {
          var composedLogistic;
          composedLogistic = {
            items: [],
            seller: {},
            selectedSla: '',
            slas: [],
            index: index
          };
          _.each(logisticsInfo, function(info) {
            var selectedSla;
            composedLogistic.items.push(info.item);
            composedLogistic.seller = info.seller;
            _.each(info.slas, function(sla) {
              var composedSla, isNewSLA;
              composedSla = _.find(composedLogistic.slas, function(_sla) {
                return _sla.id === sla.id;
              });
              if (!composedSla) {
                composedSla = _this._fillSLA(index, sla, info.seller.id, info.selectedSla);
                isNewSLA = true;
                return composedLogistic.slas.push(composedSla);
              } else {
                composedSla.price += sla.price;
                return composedSla.tax += sla.tax;
              }
            });
            composedLogistic.slas = _.map(composedLogistic.slas, _this._createPriceLabels);
            selectedSla = _.find(composedLogistic.slas, function(slas) {
              return slas.id === info.selectedSla;
            });
            return composedLogistic.selectedSla = selectedSla;
          });
          index++;
          return composedLogistic;
        });
        return logisticsInfoArray;
      };
      this._getDeliveryDates = function(deliveryWindows) {
        var _this = this;
        return _.reduce(deliveryWindows, function(deliveryDates, dw) {
          var date, dateAsArray, dateIsInArray;
          date = new Date(dw.startDateUtc);
          dateAsArray = _this.dateAsArray(date);
          dateIsInArray = _.find(deliveryDates, function(d) {
            return d[0] === dateAsArray[0] && d[1] === dateAsArray[1] && d[2] === dateAsArray[2];
          });
          if (!dateIsInArray) {
            deliveryDates.push(dateAsArray);
          }
          return deliveryDates;
        }, []);
      };
      this._fillScheduled = function(logisticsInfoArray) {
        var _this = this;
        _.each(logisticsInfoArray, function(li) {
          return _.each(li.slas, function(sla) {
            if (!sla.isScheduled) {

            } else {
              sla.deliveryDates = _this._getDeliveryDates(sla.availableDeliveryWindows);
              sla.deliveryWindows = _.groupBy(sla.availableDeliveryWindows, function(dw) {
                return _this.dateAsString(new Date(dw.startDateUtc));
              });
              _this.updateDeliveryWindowsPriceAndLabels(sla);
              if (sla.deliveryWindow) {
                return _this.selectDeliveryWindow(sla, sla.deliveryWindow);
              }
            }
          });
        });
        return logisticsInfoArray;
      };
      this.getShippingOptionsData = function(logisticsInfo, items, sellers) {
        var existsScheduledDelivery, logisticsBySeller, logisticsInfoArray, updatedLogisticsInfo,
          _this = this;
        updatedLogisticsInfo = [];
        updatedLogisticsInfo = this._mapLogisticsInfo(logisticsInfo, items, sellers);
        logisticsBySeller = _.groupBy(updatedLogisticsInfo, function(so) {
          return "seller" + so.seller.id;
        });
        logisticsInfoArray = this._fillLogisticsInfo(logisticsBySeller);
        logisticsInfoArray = this._fillScheduled(logisticsInfoArray);
        existsScheduledDelivery = _.find(logisticsInfoArray, function(li) {
          return _.find(li.slas, function(sla) {
            return sla.isScheduled;
          });
        });
        this.attr.isScheduledDeliveryAvailable = existsScheduledDelivery;
        this.setCheapestSlaIfNull(logisticsInfoArray);
        return logisticsInfoArray;
      };
      this.dateAsArray = function(date) {
        return [date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()];
      };
      this.dateAsString = function(date) {
        return date.getUTCFullYear() + '/' + (date.getUTCMonth() + 1) + '/' + date.getUTCDate();
      };
      this.dateHourMinLabel = function(date) {
        if (date) {
          return _.pad(date.getUTCHours(), 2) + ":" + _.pad(date.getUTCMinutes(), 2);
        }
      };
      this.formatDate = function(date) {
        var day, month, year;
        year = date.getUTCFullYear();
        month = date.getUTCMonth() + 1;
        day = date.getUTCDate();
        if (parseInt(day, 10) < 10) {
          day = '0' + day;
        }
        if (parseInt(month, 10) < 10) {
          month = '0' + month;
        }
        if (this.attr.locale === 'en') {
          return month + '/' + day + '/' + year;
        } else {
          return day + '/' + month + '/' + year;
        }
      };
      this.updateShippingOptionsLabels = function(currentShippingOptions) {
        var _this = this;
        if (currentShippingOptions.length > 1) {
          this.attr.data.multipleSellers = true;
        }
        return this.requireLocale().then(function() {
          var shipping, sla, _i, _len, _results;
          _results = [];
          for (_i = 0, _len = currentShippingOptions.length; _i < _len; _i++) {
            shipping = currentShippingOptions[_i];
            _results.push((function() {
              var _j, _len1, _ref, _results1;
              _ref = shipping.slas;
              _results1 = [];
              for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
                sla = _ref[_j];
                if (sla.shippingEstimate !== void 0 && !sla.isScheduled) {
                  if (sla.businessDays) {
                    sla.deliveryEstimateLabel = i18n.t('shipping.shippingOptions.businessDay', {
                      count: sla.shippingEstimateTime
                    });
                  } else if (sla.days) {
                    sla.deliveryEstimateLabel = i18n.t('shipping.shippingOptions.day', {
                      count: sla.shippingEstimateTime
                    });
                  } else if (sla.hours) {
                    sla.deliveryEstimateLabel = i18n.t('shipping.shippingOptions.hour', {
                      count: sla.shippingEstimateTime
                    });
                  } else if (sla.minutes) {
                    sla.deliveryEstimateLabel = i18n.t('shipping.shippingOptions.minute', {
                      count: sla.shippingEstimateTime
                    });
                  }
                  _results1.push(sla.fullEstimateLabel = (sla.pickupName || sla.name) + ' - ' + sla.valueLabel + ' - ' + sla.deliveryEstimateLabel);
                } else {
                  _results1.push(void 0);
                }
              }
              return _results1;
            })());
          }
          return _results;
        });
      };
      this.updateDeliveryWindowsPriceAndLabels = function(sla) {
        var dateArray, dw, key, objTranslation, value, valueLabel, _i, _len, _ref;
        sla.cheapestValue = sla.cheapestValue || Number.MAX_VALUE;
        sla.isFree = i18n.t('global.free');
        _ref = sla.deliveryWindows;
        for (key in _ref) {
          dateArray = _ref[key];
          for (_i = 0, _len = dateArray.length; _i < _len; _i++) {
            dw = dateArray[_i];
            value = dw.price + sla.price;
            if (value === 0) {
              dw.valueLabel = i18n.t('global.free');
            } else {
              sla.isFree = false;
              dw.valueLabel = _.intAsCurrency(value);
            }
            dw.startDate = new Date(dw.startDateUtc);
            dw.endDate = new Date(dw.endDateUtc);
            dw.dateAsArray = this.dateAsArray(dw.startDate);
            dw.dateString = this.dateAsString(dw.startDate);
            objTranslation = {
              from: this.dateHourMinLabel(dw.startDate),
              to: this.dateHourMinLabel(dw.endDate)
            };
            dw.label = i18n.t('shipping.shippingOptions.fromToHour', objTranslation) + ' - ' + dw.valueLabel;
            dw.timeLabel = i18n.t('shipping.shippingOptions.fromToHour', objTranslation);
            dw.formattedDate = this.formatDate(new Date(dw.startDateUtc));
            if (value < sla.cheapestValue) {
              sla.cheapestDeliveryWindow = dw;
              sla.cheapestValue = value;
              sla.cheapestValueLabel = dw.valueLabel;
              sla.cheapestEndDate = dw.endDate;
            }
          }
        }
        if (sla.isFree) {
          valueLabel = sla.isFree;
        } else {
          if (sla.hasPriceVariation) {
            valueLabel = i18n.t('shipping.shippingOptions.priceFrom') + ' ' + sla.cheapestValueLabel;
          } else {
            valueLabel = sla.cheapestValueLabel;
          }
        }
        return sla.fullEstimateLabel = (sla.pickupName || sla.name) + ' - ' + valueLabel;
      };
      this.selectDeliveryWindow = function(sla, deliveryWindow) {
        var dateAsArray, dateWindow, key, _i, _len, _ref;
        sla.deliveryWindow = deliveryWindow;
        _ref = sla.deliveryWindows;
        for (key in _ref) {
          dateAsArray = _ref[key];
          for (_i = 0, _len = dateAsArray.length; _i < _len; _i++) {
            dateWindow = dateAsArray[_i];
            if (deliveryWindow.startDateUtc === dateWindow.startDateUtc && deliveryWindow.endDateUtc === dateWindow.endDateUtc) {
              dateWindow.isWindowSelected = true;
              deliveryWindow.formattedDate = dateWindow.formattedDate;
              deliveryWindow.label = dateWindow.label;
              sla.deliveryWindowsForDate = dateAsArray;
            } else {
              dateWindow.isWindowSelected = false;
            }
          }
        }
      };
      this.updateLogisticsInfoModel = function(shippingOption, selectedSla, deliveryWindow) {
        var li, sameLi, selectedSlaObject, _i, _len, _ref;
        _ref = this.attr.data.logisticsInfo;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          li = _ref[_i];
          sameLi = _.find(shippingOption.items, function(i) {
            return i.index === li.itemIndex;
          });
          if (sameLi) {
            selectedSlaObject = _.find(li.slas, function(sla) {
              return sla.id === selectedSla;
            });
            li.selectedSla = selectedSla;
            li.deliveryWindow = deliveryWindow;
            li.selectedDeliveryChannel = (selectedSlaObject != null ? selectedSlaObject.deliveryChannel : void 0) || 'delivery';
            this._selectDeliveryWindowInsideSla(li, selectedSlaObject, deliveryWindow);
          }
        }
        if (shippingOption.selectedSla.availableDeliveryWindows.length > 0 && deliveryWindow) {
          this.selectDeliveryWindow(shippingOption.selectedSla, deliveryWindow);
        }
        return this.trigger('deliverySelected.vtex', [
          this.attr.data.logisticsInfo, {
            skipSendAttachment: true
          }
        ]);
      };
      this._selectDeliveryWindowInsideSla = function(logisticsInfo, selectedSlaObject, deliveryWindow) {
        var isScheduled;
        isScheduled = (selectedSlaObject != null ? selectedSlaObject.availableDeliveryWindows.length : void 0) > 0;
        if (isScheduled) {
          return selectedSlaObject.deliveryWindow = deliveryWindow;
        }
      };
      this.getCheapestDeliveryWindow = function(shippingOptions, date) {
        var cheapestDw, cheapestValue, dateAsString, deliveryWindows, dw, sla, _i, _len;
        sla = shippingOptions.selectedSla;
        if (date) {
          dateAsString = this.dateAsString(new Date(date));
          deliveryWindows = sla.deliveryWindows[dateAsString];
          cheapestValue = Number.MAX_VALUE;
          cheapestDw = null;
          for (_i = 0, _len = deliveryWindows.length; _i < _len; _i++) {
            dw = deliveryWindows[_i];
            if (dw.price + sla.price < cheapestValue) {
              cheapestValue = dw.price + sla.price;
              cheapestDw = dw;
            }
          }
          return cheapestDw;
        } else {
          return sla.cheapestDeliveryWindow;
        }
      };
      this.getCheapestSla = function(so) {
        var cheapestSla, cheapestValue, sla, _i, _len, _ref;
        cheapestValue = Number.MAX_VALUE;
        cheapestSla = null;
        _ref = so.slas;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          sla = _ref[_i];
          if (sla.price < cheapestValue) {
            cheapestSla = sla;
            cheapestValue = sla.price;
          }
        }
        return cheapestSla;
      };
      return this.setCheapestSlaIfNull = function(shippingOptions) {
        var cheapestSla, so, _i, _len;
        for (_i = 0, _len = shippingOptions.length; _i < _len; _i++) {
          so = shippingOptions[_i];
          if (so.selectedSla == null) {
            cheapestSla = this.getCheapestSla(so);
            if (!cheapestSla) {
              return;
            }
            so.selectedSla = cheapestSla;
            this.updateLogisticsInfoModel(so, so.selectedSla.id);
          }
        }
      };
    };
  });

}).call(this);

